import { DAY, DAYS_TO_NUMBER } from "../../consts/strings";

import { DAY_PLAN } from "../../consts/sentryIds";
import StyledChip from "./StyledChip";
import { getDepotDays } from "../../reducers/matrixProfile/selectors";
import { palette } from "../../theme/palette";
import { useSelector } from "react-redux";

export const DayChips = ({
  disableDaysNotInDepot = false,
  disableDaysInDepot = false,
  selected,
  onDaySelected,
  disabledDays = [],
}) => {
  const depotDays = useSelector(getDepotDays);

  const clickHandler = (day) => {
    onDaySelected && onDaySelected({ type: DAY, value: day });
  };

  const isSelected = (dayNumber) => {
    return Array.isArray(selected)
      ? selected.includes(dayNumber)
      : dayNumber === selected;
  };

  return Object.keys(DAYS_TO_NUMBER).map((day, index) => {
    const dayNumber = DAYS_TO_NUMBER[day];
    let disabled =
      (Array.isArray(disabledDays) && disabledDays.includes(dayNumber)) ||
      (disableDaysNotInDepot && !depotDays.includes(DAYS_TO_NUMBER[day])) ||
      (disableDaysInDepot && depotDays.includes(DAYS_TO_NUMBER[day]));

    return (
      <StyledChip
        sentryId={`${DAY_PLAN}__${dayNumber}`}
        dark
        size={"small"}
        clickable
        label={day}
        key={index}
        onClick={() => clickHandler(DAYS_TO_NUMBER[day])}
        style={
          disabled
            ? {
                backgroundColor: palette.dpdLightGrey,
                pointerEvents: "none",
                color: palette.typography.white.high,
              }
            : isSelected(dayNumber)
            ? {
                backgroundColor: palette.dpdRed,
                color: palette.typography.white.high,
              }
            : {}
        }
      />
    );
  });
};
